import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';

export const patchAdminSensorOrder = async (orderId, orderData) => {
  const signedRequest = await createSignedPatchRequest({
    apiPath: `admin/renolog/sensor-orders/${orderId}`,
    body: orderData,
    //isLocalApiRequest: true,
  });
  const response = await axios(signedRequest);
  return response.data;
};
